// extracted by mini-css-extract-plugin
export default {"removeButton":"sPzKggwuqlErA9OaHjPA7A==","brand":"YVPvxkKNcLwvFd8WhEygdw=="};